/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_PracticeInputs */

const en_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice between lessons`)
};

const es_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practica entre lecciones`)
};

const de_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischen den Unterrichtsstunden üben`)
};

const zh_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课间练习`)
};

const ar_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدرّب بين الدروس`)
};

const fr_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratique entre les cours`)
};

const vi_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luyện tập giữa các buổi học`)
};

const sw_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fanya mazoezi kati ya masomo`)
};

const th_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฝึกฝนระหว่างบทเรียน`)
};

const bs_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbajte između lekcija`)
};

const ja_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン間の練習`)
};

const ko_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 사이 연습`)
};

const pt_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prática entre aulas`)
};

const it_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento tra una lezione e l'altra`)
};

const sv_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öva mellan lektioner`)
};

const nl_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefening tussen lessen`)
};

const da_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træning mellem lektionerne`)
};

const nb_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening mellom timene`)
};

const fi_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoittelu tuntien välillä`)
};

const pl_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening między lekcjami`)
};

const ru_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Практика между уроками`)
};

const tr_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersler arası antrenman`)
};

const hi_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ के बीच अभ्यास`)
};

const id_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlatih di sela pelajaran`)
};

const ms_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlatih antara pelajaran`)
};

const cs_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trénink mezi lekcemi`)
};

const el_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξάσκηση ανάμεσα στα μαθήματα`)
};

const he_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תרגול בין שיעורים`)
};

const af_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefening tussen lesse`)
};

const hu_lessons_practice = /** @type {(inputs: Lessons_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlás az órák között`)
};

/**
* | output |
* | --- |
* | "Practice between lessons" |
*
* @param {Lessons_PracticeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_practice = /** @type {((inputs?: Lessons_PracticeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_PracticeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_practice(inputs)
	if (locale === "de") return de_lessons_practice(inputs)
	if (locale === "zh") return zh_lessons_practice(inputs)
	if (locale === "ar") return ar_lessons_practice(inputs)
	if (locale === "fr") return fr_lessons_practice(inputs)
	if (locale === "vi") return vi_lessons_practice(inputs)
	if (locale === "sw") return sw_lessons_practice(inputs)
	if (locale === "th") return th_lessons_practice(inputs)
	if (locale === "bs") return bs_lessons_practice(inputs)
	if (locale === "ja") return ja_lessons_practice(inputs)
	if (locale === "ko") return ko_lessons_practice(inputs)
	if (locale === "pt") return pt_lessons_practice(inputs)
	if (locale === "it") return it_lessons_practice(inputs)
	if (locale === "sv") return sv_lessons_practice(inputs)
	if (locale === "nl") return nl_lessons_practice(inputs)
	if (locale === "da") return da_lessons_practice(inputs)
	if (locale === "nb") return nb_lessons_practice(inputs)
	if (locale === "fi") return fi_lessons_practice(inputs)
	if (locale === "pl") return pl_lessons_practice(inputs)
	if (locale === "ru") return ru_lessons_practice(inputs)
	if (locale === "tr") return tr_lessons_practice(inputs)
	if (locale === "hi") return hi_lessons_practice(inputs)
	if (locale === "id") return id_lessons_practice(inputs)
	if (locale === "ms") return ms_lessons_practice(inputs)
	if (locale === "cs") return cs_lessons_practice(inputs)
	if (locale === "el") return el_lessons_practice(inputs)
	if (locale === "he") return he_lessons_practice(inputs)
	if (locale === "af") return af_lessons_practice(inputs)
	if (locale === "hu") return hu_lessons_practice(inputs)
	return en_lessons_practice(inputs)
});